import {UserData} from '@/_models/user-data';

export class AdminUserData extends UserData {
  id: string;
  username: string;
}
